import { css, SerializedStyles } from "@emotion/react";
import Markdown from "react-markdown";
import NavLink from "../../inputs/NavLink";
import { GTMEvent } from "apps/dashboard-client/utils/googleTagManagerUtils";

export type gtmData = { source: string } & Record<
  string,
  string | number | string[]
>;
type StrapiMarkdownProps = {
  text: string;
  linkTrackingEvent: GTMEvent;
  customCss?: SerializedStyles;
};

const s = {
  container: css({
    display: "flex",
    flexDirection: "column",
    rowGap: "1.6rem",
  }),
};

const StrapiMarkdown = ({
  text = "",
  customCss,
  linkTrackingEvent,
}: StrapiMarkdownProps) => {
  return (
    <div css={[s.container, customCss]}>
      <Markdown
        components={{
          a(props) {
            return (
              <NavLink
                customGtmEvent={linkTrackingEvent}
                customCss={css({ display: "inline", padding: 0 })}
                text={(props.children as string) || ""}
                openInNewTab={true}
                href={props.href}
              />
            );
          },
        }}
      >
        {text}
      </Markdown>
    </div>
  );
};

export default StrapiMarkdown;
